import React from 'react'

interface MoreIconProps {
  color?: string
  size?: number
}

/**
 * More options (three dots) icon for competition setup wizard
 */
const MoreIcon: React.FC<MoreIconProps> = ({
  color = '#F2B400',
  size = 24,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 25'
      fill='none'
    >
      <path
        d='M12 8.50049C13.1 8.50049 14 7.60049 14 6.50049C14 5.40049 13.1 4.50049 12 4.50049C10.9 4.50049 10 5.40049 10 6.50049C10 7.60049 10.9 8.50049 12 8.50049ZM12 10.5005C10.9 10.5005 10 11.4005 10 12.5005C10 13.6005 10.9 14.5005 12 14.5005C13.1 14.5005 14 13.6005 14 12.5005C14 11.4005 13.1 10.5005 12 10.5005ZM12 16.5005C10.9 16.5005 10 17.4005 10 18.5005C10 19.6005 10.9 20.5005 12 20.5005C13.1 20.5005 14 19.6005 14 18.5005C14 17.4005 13.1 16.5005 12 16.5005Z'
        fill={color}
      />
    </svg>
  )
}

export default MoreIcon
